import React, { useState, useEffect, useRef } from "react";
import useFilters from "hooks/useFilters";
import { useHistory } from "react-router-dom";
import { useStore } from "../../../store/context";
import i18n from "i18n";

import { ProductService } from "../../../services/ProductService";
import { PublicService } from "../../../services/PublicService";

import styles from "./Products.module.scss";
// import GenericListContainer from "../../../helpers/GenericListContainer";
import AdminLayout from "../../../components/MainApp/layouts/DesktopLayout";
import ProductTable from "../../../components/MainApp/organisms/Product/Table";
import LoadButtonsContainer from "../../../components/MainApp/organisms/Product/LoadButtonsContainer";
import Button from "components/Auth/atoms/buttons/RoundedButton";

import Search from "../../../components/MainApp/atoms/Filters/Search";
import FilterPanel from "../../../components/MainApp/organisms/Filters/FilterPanel";
// import filterDataSource from "./filterData";
import headers from "./headers";
import Pagination from "../../../components/MainApp/atoms/Pagination";
import Loader from "../../../components/MainApp/atoms/Loader";

import MainNotification from "../../../components/MainApp/atoms/Notification";
import SimpleSearchPanel from "components/MainApp/organisms/Filters/SimpleSearchPanel";
import { NotFoundItems } from "../components/NotFoundItems";
import { isMobile } from "helpers/Mobile";
import { capitalize } from "helpers/utils/utils_general";
// import { FALSE } from "node-sass";

const initialFilters = {
  page_size: 10,
  search: "",
  ordering: "-created_at",
  enabled: undefined,
  categories: undefined,
  brand: undefined
};

const filterTypeMap = {
  categories: { name: "categories", type: "dropdown" },
  brand: { name: "brand", type: "dropdown" },
  /*Stock: { name: "stock", type: "twoOption", default_value: undefined },*/
  enabled: {
    name: "enabled",
    type: "twoOption",
    default_value: undefined
  },
  ordering: {
    name: "ordering",
    type: "twoOption",
    default_value: "-created_at"
  }
};

const filterDataSource = [
  {
    type: "dropdown",
    options: [],
    label: capitalize(i18n.t("categories")),
    firstOptionLabel: i18n.t("all.categories"),
    name: "categories"
  },
  {
    type: "dropdown",
    options: [],
    label: capitalize(i18n.t("brand")),
    firstOptionLabel: i18n.t("all.brands"),
    name: "brand"
  },
  {
    type: "twoOption",
    options: [
      {
        selected: false,
        label: i18n.t("enabled"),
        value: true
      },
      {
        selected: false,
        label: i18n.t("disabled"),
        value: false
      }
    ],
    label: i18n.t("product.status"),
    firstOptionLabel: i18n.t("all.m"),
    name: "enabled"
  }
];

export const ProductsView = () => {
  const [productFilters, setProductFilters] = useState();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [noproducts, setNoProducts] = useState(false);
  const [filterData, setFilterData] = useState(filterDataSource);

  const [products_name, setProducts_name] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const myRef = useRef(0);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [loadingName, setLoadinNameg] = useState(false);


  let scrolling = false;

  const [
    filters,
    setFilters,
    selectedFiltersAll,
    selectedFiltersByType,
    handleApplyFilters,
    handleSearch,
    headerOrderingHandler,
    resetOrdering,
    handleFiltersChangeOrdering,
    applied,
    page,
    setPage,
    items,
    setItems,
    pager,
    setPager,
    header,
    setHeader,
    mobilePanelOpen,
    setMobilePanelOpen
  ] = useFilters(
    initialFilters,
    productFilters,
    filterTypeMap,
    isMobile,
    headers
  );

  useEffect(() => {
    fillFilterData();
  }, []);

  useEffect(() => {
    const first_load =
      JSON.stringify(initialFilters) === JSON.stringify(filters);
    filter(first_load);
    // Acomodar orden
    const keyOrdering =
      filters.ordering.charAt(0) === "-"
        ? filters.ordering.substr(1)
        : filters.ordering;
    if (keyOrdering in headers) {
      const newHeaders = { ...header };
      newHeaders[keyOrdering]["active"] = true;
      newHeaders[keyOrdering]["direction"] =
        filters.ordering === keyOrdering ? true : false;
      setHeader(newHeaders);
    }
  }, []);

  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
      return;
    }
    filter(false);
    setProductFilters({
      filters: filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType
    });
  }, [filters, page]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  });

  const handleScroll = event => {
    if (!isMobile) return;

    if (
      event.srcElement.offsetHeight + event.target.scrollTop + 100 <
      event.srcElement.scrollHeight
    )
      return;

    if (!pager.next || submitted || scrolling) return;
    scrolling = true;

    setPage(page + 1);
  };

  const handlePagerChange = function (page) {
    setPage(page);
  };

  const filter = function (firstLoad = false) {
    let append = isMobile;
    if (!append) {
      setItems([]);
    }

    //BEFORE SUBMIT
    document.body.style.cursor = "wait";
    setSubmitted(true);

    const data = { ...filters, page: page };
    data["categories"] = data["categories"]
      ? data["categories"].join(",")
      : undefined;
    data["brand"] = data["brand"] ? data["brand"].join(",") : undefined;
    if (data.search) data.search = data.search.trim();
    PublicService.products_plain(data).then((response) => {
      setSubmitted(false);
      document.body.style.cursor = "default";
      scrolling = false;

      if (firstLoad && response.count === 0) {
        history.push("/admin/products/load");
        setNoProducts(true);
        return;
      }

      const newProducts = append
        ? [...items, ...response.results]
        : response.results;

      setLoading(false);
      setItems(newProducts);
      setPager({
        next: response.next,
        previous: response.previous,
        count: response.count,
        countPages: Math.ceil(response.count / filters.page_size)
      });
    }).catch(e => {
      setSubmitted(false);
      document.body.style.cursor = "default";
      scrolling = false;
    });
  };

  /*const filterProducts = () => {
       ProductService.productsName()
       .then(response => {
         setProducts_name(response);
          }).finally(() => setLoading(false));
  }*/

  const filterProducts = (value) => {
    if (value.length > 2) {
      setLoadinNameg(true);
      return new Promise((resolve, reject) => {
        var filter = [];
        filter["search"] = value;

        ProductService.productsName({ page_size: 999999, search: value }).then(
          response => {
            setProducts_name(response);
            resolve(response);
            setLoadinNameg(false);
          }
        ).catch(error => {
          resolve([]);
          setLoadinNameg(false);
        });
      });
    }
  }

  const fillFilterData = function () {
    // Usa hasta 2k categories/brands porque es un monton para renderizar

    let filterDataAux = [...filterData];
    PublicService.categories().then(response => {
      let results = response.slice(0, 2000).map(option => {
        option.label = option.name;
        option.selected = false;
        option.type = option.name;
        return option;
      });
      filterDataAux[0].options = results;
      // this.forceUpdate();
    });

    PublicService.brands().then(response => {
      let results = response.slice(0, 2000).map(option => {
        option.label = option.name;
        option.selected = false;
        return option;
      });
      filterDataAux[1].options = results;
      // this.forceUpdate();
    });

    filterDataAux[2].options = filterDataAux[2].options.map(option => {
      option.selected = false;
      return option;
    });
    /*
        filterDataAux[3].options = filterDataAux[3].options.map(option => {
          option.selected = false;
          return option;
        });*/

    if (isMobile) {
      filterDataAux[4] = {
        type: "twoOption",
        options: [
          {
            selected: false,
            label: i18n.t("less.recent"),
            value: "created_at"
          }
        ],
        label: i18n.t("order.by"),
        firstOptionLabel: i18n.t("latest"),
        value: "-created_at"
      };
    }
    setFilterData(filterDataAux);
  };

  const goToProductDetailPage = event => {
    history.push(
      `/admin/products/details/${event.currentTarget.dataset.productId}`
    );
  };

  const headerOptions = [
    {
      icon: "icon-iconos_mas2",
      name: "add",
      handler: () => {
        history.push("/admin/products/load");
      },
      tooltip: i18n.t("add.products")
    },
    {
      icon: "icon-iconos_categorìas",
      name: "categories",
      handler: () => {
        history.push("/admin/categories");
      },
      tooltip: capitalize(i18n.t("categories")),
    }
  ];

  const headerOptionsIcons = [
    {
      icon: "embalaje",
      name: "embalajes",
      handler: () => {
        history.push(`/admin/embalajes`);
      },
      tooltip: i18n.t("packagings")
    }
  ];

  const tableContentDesktop = (
    <React.Fragment>
      {/* <div className={styles["report-button-wrapper"]}>
        <div className={styles["report-button"]}>
          <Button legend="Reporte" state="enabled" />
        </div>
      </div> */}

      <FilterPanel
        resultList={products_name}
        placeholder={i18n.t("search.by.name.or.code")}
        searchValue={filters.search}
        handleSubmitSearch={handleSearch}
        filters={filterData}
        selectedFiltersAll={selectedFiltersAll}
        selectedFiltersByType={selectedFiltersByType}
        handleApplyFilters={handleApplyFilters}
        filterProducts={filterProducts}
      ></FilterPanel>

      {items.length > 0 && (
        <div className={styles["table-products-table"]}>
          <div className={styles["table-products-top-table"]}>
            <div className={styles["table-products-top-total"]}>
              {i18n.t("total").toUpperCase()}{" "}
              <span className={styles["table-products-top-total-bold"]}>
                ({pager.count})
              </span>
            </div>
            <div className={styles["table-products-top-sort"]}>
              <div
                data-automation-id="table-products-sort"
                className={
                  filters.ordering.includes("created_at")
                    ? `${styles["table-products-top-sort"]} ${styles["table-products-active-filter"]}`
                    : styles["table-products-top-sort"]
                }
                onClick={() => {
                  handleFiltersChangeOrdering(
                    "ordering",
                    filters.ordering === "-created_at"
                      ? "created_at"
                      : "-created_at"
                  );
                  resetOrdering();
                }}
              >
                {filters.ordering === "created_at" ? (
                  <React.Fragment>
                    {i18n.t("less.recent")}{" "}
                    <i className={`icon-chevron  ${styles["table-products-top-icon"]}`}></i>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {" "}
                    {i18n.t("latest")}{" "}
                    <i className={`icon-chevron-down ${styles["table-products-chevron-down"]}  ${styles["table-products-top-icon"]}`}></i>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <ProductTable
            products={items}
            headers={header}
            headerClickHandler={headerOrderingHandler}
            handleClickProduct={goToProductDetailPage}
          />
        </div>
      )}

      {items.length === 0 && !submitted && (
        <NotFoundItems />
      )}
      {items.length > 0 && (
        <div>
          <Pagination
            pageQuantity={pager.countPages}
            currentPage={page}
            pageChangeHandler={handlePagerChange}
          />
        </div>
      )}
    </React.Fragment>
  );

  const tableContentMobile = (
    <React.Fragment>
      <div className={styles["table-products-filter-container"]}>
        <SimpleSearchPanel
          placeholder={i18n.t("search.by.name.or.code")}
          handleSubmit={handleSearch}
        ></SimpleSearchPanel>
      </div>
      {/* <div className={styles["report-button-wrapper"]}>
        <div className={styles["report-button"]}>
          <Button legend="Reporte" state="enabled" />
        </div>
      </div> */}
      <div
        className={`${styles["table-products-mobile-panel"]} ${mobilePanelOpen ? styles["opened"] : ""} `}
      >
        <FilterPanel
          resultList={products_name}
          placeholder={i18n.t("search.by.name.or.code")}
          searchValue={filters.search}
          handleSubmitSearch={handleSearch}
          filters={filterData}
          selectedFiltersAll={selectedFiltersAll}
          selectedFiltersByType={selectedFiltersByType}
          handleApplyFilters={handleApplyFilters}
          closeMobilePanel={() => {
            setMobilePanelOpen(false);
          }}
        ></FilterPanel>
      </div>
      <div className={styles["table-products-table"]}>
        <div className={styles["table-products-top-table"]}>
          <div className={styles["table-products-top-total"]}>
            {capitalize(i18n.t("total"))}{" "}
            <span className={styles["table-products-top-total-bold"]}>
              ({pager.count})
            </span>
          </div>
          <div
            className={`${styles["table-products-top-sort"]} ${applied ? styles["table-products-active-filter"] : ""}`}
            onClick={() => {
              setMobilePanelOpen(true);
            }}
          >
            <i className={`icon-iconos_filtros ${styles[" table-products-top-icon"]}`}></i>
          </div>
        </div>
        <ProductTable
          products={items}
          headers={header}
          handleClickProduct={goToProductDetailPage}
        />
      </div>

      {items.length === 0 && !submitted && (
        <NotFoundItems />
      )}
    </React.Fragment>
  );

  const tableContent = isMobile ? tableContentMobile : tableContentDesktop;

  const noproductcontent = (
    <div className={styles["table-load-products-content"]}>
      <div className={styles["table-load-products-title"]}>
       {i18n.t("no.product.content.info")}
      </div>
      <LoadButtonsContainer
        handleSingleProductClick={() =>
          history.push("/admin/products/load-single-product")
        }
        handleMassiveProductClick={() =>
          history.push("/admin/products/load-massive-product")
        }
      ></LoadButtonsContainer>
    </div>
  );
  const productsElement = noproducts ? noproductcontent : tableContent;

  const content = (
    <div className={styles["table-products-wrapper"]} ref={myRef}>
      {loading ? <Loader /> : productsElement}
      {loadingName && <Loader />}
    </div>

  );

  return (
    <div className={styles["load-products-container"]}>
      <AdminLayout
        headerTitle={i18n.t("products")}
        headerOptions={headerOptions}
        headerOptionsIcons={headerOptionsIcons}
        content={content}
        navHidden={false}
      ></AdminLayout>
      <MainNotification
        label={i18n.t("product.updated.successfully.message")}
        open={false}
      ></MainNotification>
    </div>
  );
};

export default ProductsView;
